import { useMediaQuery } from "../../hooks/useMediaQuery.js";

/**
 * Below this the docked side panel would crush the main content, so it is
 * hidden and the research agent chat lives in the expanded modal instead
 * (see `ResearchAgentShell` and `AskAlpharunButton`).
 */
const DOCKED_PANEL_MEDIA_QUERY = "(min-width: 1024px)";

/** Whether the viewport is wide enough to dock the research agent panel. */
export function useIsDockedPanelViewport(): boolean {
  return useMediaQuery(DOCKED_PANEL_MEDIA_QUERY);
}
